module.exports = __webpack_public_path__ + "static/media/Glossary.Icon.4e26e539.svg";